<template>
    <span class="widget-bookmark">
        <a class="d-flex align-items-center h-100" v-if="isFavorited" @click.prevent="toggleFavorite(post)">
            <span class="font-size-small mr-2">Mentve</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17.41" viewBox="0 0 14 17.41">
                <path d="M12.78,17.3,7.56,13.42a.93.93,0,0,0-1.12,0L1.22,17.3A.82.82,0,0,1,0,16.59v-13A3.58,3.58,0,0,1,3.58,0h6.84A3.58,3.58,0,0,1,14,3.58v13A.82.82,0,0,1,12.78,17.3Z" fill="#4a90e2"/>
            </svg>

        </a>
        <a class="d-flex align-items-center h-100" v-else @click.prevent="toggleFavorite(post)">
            <span class="font-size-small mr-2">Mentés</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17.41" viewBox="0 0 14 17.41">
                <path d="M10.42,1A2.59,2.59,0,0,1,13,3.58V16.22L8.16,12.61a2,2,0,0,0-2.32,0L1,16.22V3.58A2.59,2.59,0,0,1,3.58,1h6.84m0-1H3.58A3.58,3.58,0,0,0,0,3.58v13a.82.82,0,0,0,.82.82.83.83,0,0,0,.4-.11l5.22-3.88a.92.92,0,0,1,1.12,0l5.22,3.88a.83.83,0,0,0,.4.11.82.82,0,0,0,.82-.82v-13A3.58,3.58,0,0,0,10.42,0Z" fill="#4a90e2"/>
            </svg>
        </a>
    </span>
</template>

<script>
    export default {
        props: ['post', 'favorited'],

        data: function() {
            return {
                isFavorited: '',
            }
        },

        mounted() {
            // Init from passed parameter
            this.isFavorited = this.isFavorite ? true : false;
        },

        computed: {
            isFavorite() {
                return this.favorited;
            },
        },

        methods: {
            toggleFavorite(post) {

                // AJAX post
                axios.post('/hirdetes/bookmark/'+post)
                    .then(response => {
                        // Update based on the response
                        this.isFavorited = response.data.isFavorited;

                        // Emit updated event to other components
                        this.$eventBus.$emit('bookmark.counter.updated', response.data.bookmarkCount);

                        if (this.isFavorited) {
                            this.showAlert('success', 'Kedvencekhez hozzáadva');
                        } else {
                            this.showAlert('info', 'Kedvencekből eltávolítva');
                        }

                    })
                    .catch(response => console.log(response.data));
            },

            showAlert(icon, text) {
                swal({
                    'text': text,
                    'buttons': {},
                    'title': '',
                    'icon': icon,
                    'closeOnClickOutside': true,
                    'allowOutsideClick': true,
                    timer: 1000
                });
            }
        }
    }
</script>